// extracted by mini-css-extract-plugin
export default {"stats":"statsMobile_stats__uDynO","statsBoxWrapper":"statsMobile_statsBoxWrapper__OWLtA"};